/* eslint-disable react-hooks/exhaustive-deps */
import {AccessRights} from "lib/constants/accessRights";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import MainPageComponent from "./account.page";
import LoadingComponent from "components/loading";
import { getLang } from "app/feature/constants";
import qs from "query-string";
import { ROOT } from "modules/account/config/account.route";
import {canAccess} from "../../../profile/redux/selector/profile.selector";

function MainPageContainer() {
  const history = useHistory();
  const location = useLocation();
  const hasCompanyInfoViewAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Company.INFO_READ)
  );
  const hasCompanyProductViewAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Company.PRODUCT_PAGE_READ)
  );
  const hasCompanyCurrencyViewAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Company.CURRENCY_READ)
  );
  const hasCompanyStockViewAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Company.STOCK_MODULE_READ)
  );
  const hasIntegrationViewAccessRight = useSelector(
    (state) =>
      canAccess(state, AccessRights.Company.INTEGRATION_WRITE)
  );
  const hasSmtpEditAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Company.SMTP)
  );
  const hasConsumerEngagementViewAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Company.CONSUMER_ENGAGEMENT_READ));
  const disbursementInfos = useSelector(
    (state) => state.account.disbursementInfos
  );
  const [activeIndex, setActiveIndex] = useState(0);
  const lang = useSelector((state) => state.constant.languages);

  const qsParams = qs.parse(location.search);
  const currentSearch = qsParams.tab || "";

  const availableTabs = {
    info: getLang(lang, "label.INFO_DOCUMENT"),
    product: getLang(lang, "label.PRODUCT_PAGE_SETTING"),
    currency: getLang(lang, "label.CURRENCY_SETTING"),
    stock: getLang(lang, "label.STOCK_MODULE_SETTING"),
    integration: getLang(lang, "label.INTEGRATION_SETTINGS"),
    smtp: getLang(lang, "label.SMTP_SETTINGS"),
  };

  const tabLabels = [];
  if (hasCompanyInfoViewAccessRight) tabLabels.push(availableTabs.info);
  if (hasCompanyProductViewAccessRight) tabLabels.push(availableTabs.product);
  if (hasCompanyCurrencyViewAccessRight) tabLabels.push(availableTabs.currency);
  if (hasCompanyStockViewAccessRight) tabLabels.push(availableTabs.stock);
  if (hasIntegrationViewAccessRight) tabLabels.push(availableTabs.integration);
  if (hasSmtpEditAccessRight) tabLabels.push(availableTabs.smtp);

  useEffect(() => {
    if (
      !hasCompanyInfoViewAccessRight &&
      !hasCompanyProductViewAccessRight &&
      !hasCompanyCurrencyViewAccessRight &&
      !hasCompanyStockViewAccessRight &&
      !hasIntegrationViewAccessRight
    ) {
      history.push("/admin/dashboard");
    }
  }, [
    history,
    hasCompanyInfoViewAccessRight,
    hasCompanyProductViewAccessRight,
    hasCompanyCurrencyViewAccessRight,
    hasCompanyStockViewAccessRight,
    hasIntegrationViewAccessRight,
    hasConsumerEngagementViewAccessRight,
    disbursementInfos,
  ]);

  useEffect(() => {
    let tabIndex = -1;
    switch (currentSearch) {
      case "info":
        tabIndex = tabLabels.findIndex((t) => t === availableTabs.info);
        break;
      case "product":
        tabIndex = tabLabels.findIndex((t) => t === availableTabs.product);
        break;
      case "currency":
        tabIndex = tabLabels.findIndex((t) => t === availableTabs.currency);
        break;
      case "stock":
        tabIndex = tabLabels.findIndex((t) => t === availableTabs.stock);
        break;
      case "integration":
        tabIndex = tabLabels.findIndex((t) => t === availableTabs.integration);
        break;
      case "engagement":
        tabIndex = tabLabels.findIndex((t) => t === availableTabs.engagement);
        break;
      case "smtp":
        tabIndex = tabLabels.findIndex((t) => t === availableTabs.smtp);
        break;
      default:
        tabIndex = 0;
    }
    if (tabIndex < 0) {
      history.replace({
        pathname: ROOT,
        search: `?tab=${Object.keys(availableTabs).find(
          (key) => availableTabs[key] === tabLabels[0]
        )}`,
      });
    }
    setActiveIndex(tabIndex);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSearch]);

  if (
    !hasCompanyInfoViewAccessRight &&
    !hasCompanyProductViewAccessRight &&
    !hasCompanyCurrencyViewAccessRight &&
    !hasCompanyStockViewAccessRight &&
    !hasIntegrationViewAccessRight
  )
    return <LoadingComponent />;

  const handleChange = (event, index) => {
    setActiveIndex(index);
    let selectedTab = tabLabels[index];

    history.replace({
      pathname: ROOT,
      search: `?tab=${Object.keys(availableTabs).find(
        (key) => availableTabs[key] === selectedTab
      )}`,
    });
  };

  return (
    <>
      <MainPageComponent
        handleChange={handleChange}
        activeIndex={activeIndex}
        tabLabels={tabLabels}
        lang={lang}
        availableTabs={availableTabs}
      />
    </>
  );
}

export default MainPageContainer;
